import React, { useEffect, useRef } from "react";
import {
  formatTagLabel,
  getSubjectTagStyle,
  getTagDisplayLabel,
} from "../../utils/myNotes";

function NoteFilterPanel({ tags, selectedTags, onToggleTag, onClear, onClose }) {
  const panelRef = useRef(null);

  const subjectOnly = [
    "AMAC",
    "Economy",
    "Environment/Disaster Management",
    "Ethics",
    "Geography",
    "Governance",
    "Internal Security",
    "International Relations",
    "Modern History",
    "Polity",
    "Post Independence",
    "Science & Tech",
    "Society/Social Justice",
    "World History",
     "Essay",
  ]; // by sudz - only these subjects in filter

  const filteredTags = subjectOnly.filter((tag) => tags.includes(tag)); // by sudz

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        onClose?.();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [onClose]);

  return (
    <div className="my-notes-filter-panel" ref={panelRef}>
      <div className="my-notes-filter-panel-header"></div>
      <div className="my-notes-filter-tags">
        {filteredTags.map((tag) => {
          const isSelected = selectedTags.includes(tag);
          const tagStyle = getSubjectTagStyle(tag);
          return (
            <button
              key={tag}
              type="button"
              className={`my-notes-filter-tag ${isSelected ? "is-selected" : ""}`}
              style={
                isSelected
                  ? {
                      backgroundColor: tagStyle.backgroundColor,
                      color: tagStyle.color,
                      borderColor: tagStyle.borderColor,
                    }
                  : {
                      borderColor: tagStyle.borderColor,
                      color: tagStyle.text,
                    }
              }
              title={formatTagLabel(tag)}
              onClick={() => onToggleTag?.(tag)}
            >
              {/* {getTagDisplayLabel(tag)} */}
              {tag}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default NoteFilterPanel;
